import { render } from "./HiFormHiveStandard.vue?vue&type=template&id=afd0add8"
import script from "./HiFormHiveStandard.vue?vue&type=script&lang=js"
export * from "./HiFormHiveStandard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__